define(function(require){

	require('jquery.inputmask');
    require('jquery.inputmask.multi');
    require('jquery.bind.first');

    var maskList = $.masksLoad("phone-codes.json");// $.masksSort($.masksLoad("phone-codes.json"), ['#'], /[0-9]|#/, "mask");
    var options = {
        inputmask: {
            definitions: {
                '#': {
                    validator: "[0-9]",
                    cardinality: 1
                }
            },
            //clearIncomplete: true,
            showMaskOnHover: false,
            autoUnmask: true
        },
        match: /[0-9*]/,
        replace: '#',
        list: maskList,
        listKey: "mask",
        defaultMask: '+7(###)###-##-##'
    };

    return $.extend({}, options, {
        onMaskChange: function(maskObj, completed) {
            $(this).attr("placeholder", $(this).inputmask("getemptymask"));
        },
        onInit: function(mask, determined) {

        }
    })
});

